import React, { useEffect, useState } from 'react';
import styles from "./Home.module.scss";
import { Link, useNavigate } from 'react-router-dom';
import { bannerInfo, businessTypes, howWork, whyChoose } from '../../configration_data/configration';
import { Tooltip, Autocomplete, TextField } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import './slick-theme-local.css';
import Rating from 'react-rating-stars-component';
import { useConfig } from '../../../app/configcontext';
import { reset_state, update_business_id, update_business_state } from '../../../features/business/businessSlice';
import { useDispatch } from 'react-redux';
import ProtectedPaymentRoute from '../../auth/Auth';
import bannerMen from './banner_men.png';
import Logo from '../Navbar/logo.png';
import { styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import { MdOutlineCheckCircle, MdOutlineInfo } from 'react-icons/md';

const CustomDropdown = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = (options || []).filter((opt) => {
    const name = typeof opt === "string" ? opt : opt?.name || "";
    return name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`min-w-[130px] max-w-[155px] bg-white border ${
          isOpen ? "border-[#1a73e8] ring-2 ring-[#e8f0fe]" : "border-[#dadce0]"
        } text-[#202124] text-[13.5px] font-medium rounded-[6px] px-3 py-1.5 flex justify-between items-center cursor-pointer hover:border-[#1a73e8] transition-all shadow-sm h-[36px]`}
      >
        <span className="truncate mr-1">{value || placeholder}</span>
        <svg
          className={`fill-current h-4 w-4 text-[#5f6368] shrink-0 transition-transform duration-200 ${
            isOpen ? "rotate-180 text-[#1a73e8]" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-[100] right-0 mt-1.5 w-[220px] bg-white border border-[#dadce0] rounded-[8px] shadow-2xl flex flex-col origin-top overflow-hidden">
          <div className="p-2 border-b border-[#f1f3f4] bg-[#f8f9fa]">
            <input
              type="text"
              autoFocus
              className="w-full bg-white border border-[#dadce0] rounded-[4px] px-2.5 py-1.5 text-[13px] text-[#202124] placeholder-[#9aa0a6] focus:outline-none focus:border-[#1a73e8] focus:ring-1 focus:ring-[#1a73e8]"
              placeholder="Search state..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul className="py-1 overflow-y-auto max-h-[220px] list-none m-0 p-0">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, idx) => {
                const optName = typeof option === "string" ? option : option?.name || "";
                return (
                  <li
                    key={idx}
                    onClick={() => {
                      onChange(optName);
                      setIsOpen(false);
                      setSearchTerm("");
                    }}
                    className={`px-3.5 py-2 text-[13.5px] text-[#202124] hover:bg-[#f1f3f4] cursor-pointer transition-colors flex items-center justify-between whitespace-nowrap ${
                      value === optName ? "bg-[#e8f0fe] text-[#1a73e8] font-medium" : ""
                    }`}
                  >
                    <span>{optName}</span>
                    {value === optName && <span className="text-[#1a73e8] text-xs ml-2">✓</span>}
                  </li>
                );
              })
            ) : (
              <li className="px-3 py-3 text-[13px] text-[#5f6368] italic text-center">No states found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default function Home() {
  ProtectedPaymentRoute();
  const config = useConfig();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState({});
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  let businessTypesId = config?.businessType;
  businessTypesId?.sort((a, b) => a.id - b.id);
  const typeList = businessTypesId?.map((ele) => {
    const businessType = businessTypes?.find((type) => type.id === ele.id);
    return businessType ? businessType?.typeList : [];
  });

  const states = config?.states;

  const handleClick = (index) => {
    const selectedBusinessType = businessTypesId[index];
    if (selectedState[selectedBusinessType.id]) {
      dispatch(update_business_id(selectedBusinessType.id));
      if (selectedBusinessType.id === 1) {
        navigate("/services/llc-formation");
      } else if (selectedBusinessType.id === 2) {
        navigate("/services/corporation-formation");
      }
    } else {
      setErrorModal({ show: true, message: "Please select a state to proceed with your business registration." });
    }
  };

  const handleStateSelection = (eleId, stateName) => {
    setSelectedState((prevState) => ({ ...prevState, [eleId]: stateName }));
    dispatch(update_business_state({ state: stateName }));
  };

  useEffect(() => {
    const stripeAccess = localStorage.getItem("stripeAccess");
    if (!stripeAccess) {
      localStorage.clear();
      dispatch(reset_state());
    }
  }, [dispatch]);

  const testimonials = [
    {
      id: 1,
      name: 'John Doe',
      position: 'CEO, Company A',
      rating: 3.5,
      comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      id: 2,
      name: 'Jane Smith',
      position: 'Manager, Company B',
      rating: 5,
      comment: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 3,
      name: 'Jane Smith',
      position: 'Manager, Company B',
      rating: 4,
      comment: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 4,
      name: 'Jane Smith',
      position: 'Manager, Company B',
      rating: 3.5,
      comment: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 5,
      name: 'Jane Smith',
      position: 'Manager, Company B',
      rating: 4,
      comment: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 6,
      name: 'Jane Smith',
      position: 'Manager, Company B',
      rating: 3.5,
      comment: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  // Google Blue color reference: #1a73e8
  // Google Text reference: #202124 (headings), #5f6368 (body)

  return (
    <div className="font-sans antialiased text-[#202124] selection:bg-[#1a73e8] selection:text-white bg-white">

      {/* Hero Section */}
      <section className="relative overflow-hidden lg:h-[750px] pt-24 pb-16 lg:pt-0 lg:pb-0 border-b border-[#0f2c4f]"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}>

        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container relative z-10 mx-auto h-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center h-full">

            {/* Left Content (Text) */}
            <div className="col-span-1 lg:col-span-6 flex flex-col justify-center pr-0 lg:pr-8">
              <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-[580px]">
                {bannerInfo.heading}
              </h1>

              <p className="text-lg md:text-[1.15rem] text-white/80 mb-10 leading-[1.7] font-normal max-w-[540px]">
                {bannerInfo.peragraph}
              </p>

              <div className="flex items-center gap-4 flex-wrap">
                <Link to="/contact-us" className="bg-[#1a73e8] text-white px-9 py-3.5 rounded-[4px] font-medium text-[16px] hover:bg-[#1557b0] transition-colors shadow-lg hover:shadow-[0_8px_25px_rgba(26,115,232,0.5)] flex items-center justify-center">
                  {bannerInfo.button}
                </Link>
              </div>
            </div>

            {/* Right Content (Empty Grid Space to balance layout) */}
            <div className="col-span-1 lg:col-span-6 hidden lg:block"></div>
          </div>

          {/* The Transparent Person Image (Absolutely positioned to sit perfectly on the bottom) */}
          <div className="absolute bottom-0 right-[2%] h-[85%] max-h-[650px] z-0 hidden lg:block pointer-events-none">
            <img
              src={bannerMen}
              alt="Professional"
              className="w-auto h-full object-contain object-bottom drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]"
              style={{ marginBottom: "-1px" }}
            />
          </div>

        </div>
      </section>

      {/* Business Type Section */}
      <section className="py-20 bg-white" id="pricing">
        <div className="container">
          <div className="text-center max-w-[760px] mx-auto mb-14">
            <h2 className="text-3xl md:text-4xl font-normal text-[#202124] mb-4">Start your business today</h2>
            <p className="text-lg text-[#5f6368]">Quick, Affordable, and Reliable Services to Launch and Grow Your Business</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
            {businessTypesId && businessTypesId.map((ele, index) => {
              let displayName = ele.name === "Limited liability company" ? "LLC" : ele.name;
              displayName = ele.name === "Benificial OwnerShip Information Report" ? "File BOIR" : displayName;

              return (
                <div key={ele.id} className="bg-white rounded-[8px] border border-[#dadce0] hover:shadow-md transition-shadow duration-200 p-6 flex flex-col h-full group">

                  <div className="flex items-center justify-between mb-6 pb-4 border-b border-[#f1f3f4] min-h-[60px]">
                    <h5 className="text-[22px] font-normal text-[#202124]">{displayName}</h5>

                    {displayName !== "File BOIR" && (
                      <CustomDropdown
                        options={states || []}
                        value={selectedState[ele.id]}
                        onChange={(value) => handleStateSelection(ele.id, value)}
                        placeholder="State"
                      />
                    )}
                  </div>

                  <div className="flex-1">
                    <ul className="space-y-4 mb-8">
                      {typeList && typeList[index]?.map((i) => {
                        const content = (
                          <li className="group relative flex items-start gap-3 text-[14px] text-[#3c4043] cursor-default hover:bg-[#f8f9fa] p-1.5 -mx-1.5 rounded-[4px] transition-colors">
                            <MdOutlineCheckCircle className="text-[#1a73e8] text-[20px] shrink-0 mt-[1px]" />
                            <span className="leading-relaxed flex-1">{i.listName}</span>

                            {i.tooltip && (
                              <div className="mt-[2px]">
                                <MdOutlineInfo className="text-[#9aa0a6] group-hover:text-[#1a73e8] text-[18px] cursor-help transition-colors" />
                              </div>
                            )}
                          </li>
                        );

                        return i.tooltip ? (
                          <Tooltip key={i.listName} title={i.tooltip} placement="top" arrow>
                            {content}
                          </Tooltip>
                        ) : (
                          <React.Fragment key={i.listName}>{content}</React.Fragment>
                        );
                      })}
                    </ul>
                  </div>

                  <div className="mt-auto relative">
                    <button
                      onClick={() => handleClick(index)}
                      disabled={displayName === "File BOIR"}
                      className={`w-full py-2.5 px-4 rounded-[4px] font-medium text-[14px] transition-colors h-[40px] flex items-center justify-center ${displayName === "File BOIR"
                          ? "bg-[#f1f3f4] text-[#3c4043] cursor-not-allowed opacity-60"
                          : "bg-[#1a73e8] text-white hover:bg-[#1557b0]"
                        }`}
                    >
                      {displayName === "File BOIR" ? "Coming Soon" : `Register ${displayName}`}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa]">
        <div className="container">
          <div className="mb-12 lg:mb-16 text-center">
            <h2 className="text-[28px] md:text-[32px] lg:text-[36px] font-normal text-[#202124] mb-4">How Oktobiz works</h2>
            <p className="text-[16px] lg:text-[18px] text-[#5f6368] max-w-[600px] mx-auto">A simple, transparent process to get your business up and running.</p>
          </div>

          <div className="flex flex-col gap-6 lg:gap-10">
            {howWork.map((ele, idx) => (
              <div key={ele.name} className={`bg-white rounded-[12px] p-6 md:p-8 lg:p-10 flex flex-col md:flex-row items-center gap-8 lg:gap-12 shadow-[0_1px_3px_rgba(0,0,0,0.05),0_1px_2px_rgba(0,0,0,0.03)] border border-[#dadce0]/50 ${idx % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>

                {/* Image Side */}
                <div className="w-full md:w-5/12 aspect-[16/9] md:aspect-auto md:h-[260px] lg:h-[300px] bg-[#f1f3f4] rounded-[8px] overflow-hidden flex-shrink-0 border border-[#dadce0]/50">
                  <img src={ele.img} alt={ele.name} className="w-full h-full object-cover" />
                </div>

                {/* Text Side */}
                <div className="w-full md:w-7/12 flex flex-col justify-center">
                  <h4 className="text-[22px] lg:text-[26px] font-normal text-[#202124] mb-3 leading-tight">{idx + 1}. {ele.name}</h4>
                  <p className="text-[#5f6368] leading-relaxed mb-6 text-[15px] lg:text-[16px]">{ele.pera}</p>

                  <ul className="flex flex-col w-full">
                    {ele.typeList.map((i) => (
                      <li key={i.list} className="flex items-start gap-3 text-[14px] lg:text-[15px] text-[#3c4043] py-3.5 border-b border-[#f1f3f4] last:border-0">
                        <MdOutlineCheckCircle className="text-[#1a73e8] text-[20px] shrink-0 mt-[1px]" />
                        <span className="leading-relaxed">{i.list}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 lg:py-28 bg-[#202124] text-white relative overflow-hidden">

        {/* Google-Style Abstract Background */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
          {/* Plus Grid Overlay (Google Cloud Style) */}
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0yMCAxOXYyaC0xOXYtMmgxOXoiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNikiLz48cGF0aCBkPSJNMjEgMjB2MTloLTJ2LTE5aDJ6IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMDYpIi8+PC9zdmc+')] opacity-100"></div>

          {/* Core Google Colors as soft ambient glows */}
          <div className="absolute top-[-10%] right-[-5%] w-[400px] lg:w-[600px] h-[400px] lg:h-[600px] rounded-full bg-[#4285F4] opacity-[0.08] blur-[100px] lg:blur-[140px]"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-[400px] lg:w-[500px] h-[400px] lg:h-[500px] rounded-full bg-[#34A853] opacity-[0.06] blur-[100px] lg:blur-[140px]"></div>
          <div className="absolute top-[30%] left-[-10%] w-[300px] h-[300px] rounded-full bg-[#EA4335] opacity-[0.06] blur-[80px]"></div>
          <div className="absolute bottom-[20%] right-[10%] w-[250px] h-[250px] rounded-full bg-[#FBBC05] opacity-[0.05] blur-[80px]"></div>
        </div>

        <div className="container relative z-10">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">

            {/* Text / Image Side */}
            <div className="w-full lg:w-5/12 flex flex-col justify-center">
              <span className="text-[#8ab4f8] text-[13px] font-semibold tracking-wider uppercase mb-4 block">Why Oktobiz</span>
              <h3 className="text-[32px] md:text-[40px] font-normal mb-6 leading-tight">Why choose us?</h3>
              <p className="text-[16px] lg:text-[18px] text-white/80 leading-relaxed mb-10">
                Everything you need to start your business smoothly, with expert-backed support at every step. We handle the complexity so you can focus on growing.
              </p>

              <div className="w-full h-[280px] lg:h-[320px] rounded-[16px] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.3)] border border-white/10 relative group hidden sm:block">
                <div className="absolute inset-0 bg-[#021531]/20 group-hover:bg-transparent transition-colors z-10 duration-500"></div>
                <img src="Assets/why-choos.webp" alt="Why choose Oktobiz" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
              </div>
            </div>

            {/* Features Grid Side */}
            <div className="w-full lg:w-7/12 flex flex-col justify-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-6">
                {whyChoose.map((ele) => (
                  <div key={ele.number} className="bg-white/5 backdrop-blur-md rounded-[16px] p-6 lg:p-8 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
                    <div className="flex items-center gap-4 mb-5">
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1a73e8] to-[#1557b0] text-white font-medium flex items-center justify-center text-[18px] shadow-[0_4px_16px_rgba(26,115,232,0.5)]">
                        {ele.number}
                      </div>
                      <h2 className="text-[18px] lg:text-[20px] font-medium m-0 leading-tight">{ele.name}</h2>
                    </div>
                    <p className="text-[14px] lg:text-[15px] text-white/70 leading-relaxed m-0">{ele.pera}</p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-[#f8f9fa] border-t border-[#dadce0]">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-normal text-[#202124] mb-4">Testimonials</h2>
            <p className="text-[16px] text-[#5f6368] max-w-[600px] mx-auto">What our customers say about building their business with Oktobiz.</p>
          </div>

          <div className="px-4">
            <Slider {...settings} className="testimonial-slider-material">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="p-3 outline-none h-full">
                  <div className="bg-white border border-[#dadce0] rounded-[8px] p-6 shadow-sm hover:shadow transition-shadow h-full flex flex-col">
                    <div className="flex flex-col gap-2 mb-4">
                      <h4 className="text-[16px] font-medium text-[#202124]">{testimonial.name}</h4>
                      <Rating count={5} value={testimonial.rating} edit={false} activeColor="#f29900" emptyIcon={<i className="far fa-star"></i>} fullIcon={<i className="fa fa-star"></i>} size={18} />
                    </div>
                    <p className="text-[14px] text-[#5f6368] leading-relaxed italic m-0 flex-1">"{testimonial.comment}"</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* Error Modal */}
      {errorModal.show && (
        <div className="fixed inset-0 bg-[#202124]/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm transition-opacity" onClick={() => setErrorModal({ show: false, message: "" })}>
          <div className="bg-white rounded-[8px] max-w-[400px] w-full p-6 shadow-lg transition-transform" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-[20px] font-normal text-[#202124] mb-3">Notice</h3>
            <p className="text-[14px] text-[#5f6368] mb-6 leading-relaxed">{errorModal.message}</p>
            <div className="flex justify-end">
              <button className="text-[#1a73e8] font-medium text-[14px] px-4 py-2 hover:bg-[#f8f9fa] rounded-[4px] transition-colors" onClick={() => setErrorModal({ show: false, message: "" })}>
                Understood
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
